var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main kanbanfull",staticStyle:{"background":"url(static/kanban.jpg)"},attrs:{"id":"kanbanwrap"}},[(_vm.resetKanban)?_c('div',{style:({ zoom: _vm.zoom + '%' }),attrs:{"id":"kanbanwrapchild"}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ced148","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kanban/kanbanWrap.vue
// module id = null
// module chunks = 